import React from 'react';

const Header = () => {
  return (
    <header className="w3-container w3-xlarge w3-padding-24">
      <a href="#" className="w3-left w3-button w3-white">
        MY ART
      </a>
      <a href="#about" className="w3-right w3-button w3-white">
        About
      </a>
    </header>
  );
}

export default Header;
